import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98009a30"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "qr",
  class: "qr"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "image__template__container"
}
const _hoisted_4 = { class: "data__template" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "gray__base__color" }
const _hoisted_8 = { class: "gray__base__color" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "file_download", -1))
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "phone_forwarded", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("event-id-qr.title")), 1),
      (_ctx.qrCode)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            id: "qrID",
            class: "identification",
            type: "flex"
          }, {
            default: _withCtx(() => [
              (_ctx.eventData.IDTemplate && _ctx.eventData.IDTemplate.templateImage)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.eventData.IDTemplate.templateImage,
                    class: "image__template"
                  }, null, 8, _hoisted_2))
                : (_openBlock(), _createElementBlock("div", _hoisted_3)),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_col, {
                  class: "text--center width__100",
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "profile-image",
                      src: 
              _ctx.profileImage
                ? _ctx.profileImage
                : require('@/assets/no_profile_image.png')
            ,
                      alt: "Profile-image"
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, {
                  gutter: 20,
                  class: "conatiner-data-user"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      class: "text--center username gray__base__color",
                      span: 24
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.participantData.fullName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      class: "text--center",
                      span: 24
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          class: "qr-image",
                          src: _ctx.qrCode,
                          alt: "qr-code"
                        }, null, 8, _hoisted_6)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      class: "text--center ticket-type",
                      span: 24
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("event-id-qr.ticket-label")) + " - ", 1),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.ticketType), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_row, {
            key: 1,
            type: "flex"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_empty, {
                    description: _ctx.$t('event-id-qr.noData')
                  }, null, 8, ["description"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.DownloadPDF && _ctx.DownloadPDF(...args))),
          class: "button width-button secondary__color__button",
          id: "button-dw"
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("downloadQR")) + " ", 1),
          _hoisted_9
        ])
      ]),
      _: 1
    }),
    (_ctx.eventData && _ctx.eventData.generalPhone)
      ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              class: "text--center ticket-type",
              span: 24
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t("InstructionsCall")), 1),
                  _createElementVNode("a", {
                    href: 'tel:' + _ctx.eventData.generalPhone.trim()
                  }, _toDisplayString(_ctx.eventData.generalPhone), 9, _hoisted_10)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_link, {
              class: "button width-button",
              id: "button-unr",
              href: 'tel:' + _ctx.eventData.generalPhone.trim()
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Call")) + " ", 1),
                _hoisted_11
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}